import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/index.md';
import Alerts from '../resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "adobe-experience-platform-assurance-extension"
    }}>{`Adobe Experience Platform Assurance extension`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <p>{`This extension enables capabilities for Adobe Experience Platform Assurance.`}</p>
    <p>{`To get started with Assurance in your app, you'll need to:`}</p>
    <ol>
      <li parentName="ol">{`Install the AEP Assurance extension in the `}<a parentName="li" {...{
          "href": "https://experience.adobe.com/#/data-collection"
        }}>{`Data Collection UI`}</a></li>
      <li parentName="ol">{`Add AEP Assurance SDK extension library to your app`}
        <ol parentName="li">
          <li parentName="ol">{`Import AEP Assurance into your app`}</li>
          <li parentName="ol">{`Register and implement extension APIs`}</li>
        </ol>
      </li>
    </ol>
    <h2 {...{
      "id": "install-the-aep-assurance-extension-in-the-data-collection-ui"
    }}>{`Install the AEP Assurance extension in the Data Collection UI`}</h2>
    <p>{`Go to the `}<a parentName="p" {...{
        "href": "https://experience.adobe.com/#/data-collection/"
      }}>{`Experience Platform Data Collection UI`}</a>{` and select your mobile property:`}</p>
    <ol>
      <li parentName="ol">{`In the Data Collection UI, select the `}<strong parentName="li">{`Extensions`}</strong>{` tab.`}</li>
      <li parentName="ol">{`On the `}<strong parentName="li">{`Catalog`}</strong>{` tab, locate the `}<strong parentName="li">{`AEP Assurance`}</strong>{` extension, and select `}<strong parentName="li">{`Install`}</strong>{`.`}</li>
      <li parentName="ol">{`Follow the publishing process to update the Mobile SDK configuration.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "306px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "112.09150326797386%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/d09b389ed5fea15148d3bad4ffd769c0/9423a/assurance-extension.webp 306w"],
            "sizes": "(max-width: 306px) 100vw, 306px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/d09b389ed5fea15148d3bad4ffd769c0/bed10/assurance-extension.png 306w"],
            "sizes": "(max-width: 306px) 100vw, 306px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/previous-versions/static/d09b389ed5fea15148d3bad4ffd769c0/bed10/assurance-extension.png",
            "alt": "assurance extension",
            "title": "assurance extension",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "add-the-aep-assurance-extension-to-your-app"
    }}>{`Add the AEP Assurance extension to your app`}</h2>
    <h3 {...{
      "id": "import-the-library-to-your-app-code"
    }}>{`Import the library to your app code`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=import-library" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=import-library" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&task=import-library" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&task=import-library" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&task=import-library" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&task=import-library" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&task=import-library" mdxType="Tabs" />
    <h3 {...{
      "id": "register-aepassurance-with-mobile-core"
    }}>{`Register AEPAssurance with Mobile Core`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=register-assurance" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=register-assurance" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&task=register-assurance" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&task=register-assurance" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&task=register-assurance" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&task=register-assurance" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&task=register-assurance" mdxType="Tabs" />
    <h3 {...{
      "id": "implement-aep-assurance-session-start-apis-ios-only"
    }}>{`Implement AEP Assurance session start APIs (iOS only)`}</h3>
    <p>{`The `}<a parentName="p" {...{
        "href": "./assurance-api-reference.md#startsession"
      }}>{`startSession`}</a>{` API needs to be called to begin an Adobe Experience Platform Assurance session. When called, SDK displays a PIN authentication overlay to begin a session. `}</p>
    <p>{`To learn how to start sessions for other platforms, please read the `}<a parentName="p" {...{
        "href": "./api-reference.md"
      }}>{`Platform Assurance API guide`}</a>{`.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You may call this API when the app launches with a url (see code snippet below for sample usage) `}<br /><br />{` The Assurance Android extension does not require this API to be called since it registers the app lifecycle handlers which automatically pick up any deep links and use them to start the session.`}<br /><br />{`When using the Assurance iOS extension, you should call this API when the app launches with a URL (see code snippet below for sample usage).`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="1" mdxType="TabsBlock" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=implement-assurance" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      